import { queryPotocolCustomerManage } from '@/api/rnr'
import cache from '@/utils/cache'

// 个人实名
export const SET_PERSON_CONSIGNER = 'SET_PERSON_CONSIGNER'
export const SET_PERSON_BASE = 'SET_PERSON_BASE'
export const SET_PERSON_CARD = 'SET_PERSON_CARD'
export const SET_PERSON_FILE = 'SET_PERSON_FILE'
export const SET_PERSON_IDCARD = 'SET_PERSON_IDCARD'
export const SET_PERSON_PAPER = 'SET_PERSON_PAPER'
export const SET_PERSON_AGREEMENT = 'SET_PERSON_AGREEMENT'
export const RESET_PERSON = 'RESET_PERSON'
export const SET_PERSON_CONSIGNER_CARD = 'SET_PERSON_CONSIGNER_CARD'
export const SET_PERSON_DUTY_PIC = 'SET_PERSON_DUTY_PIC'
export const SET_OCR_PIC = 'SET_OCR_PIC'
export const RESET_OCR_PIC = 'RESET_OCR_PIC'

// 初始化远程配置的协议
export const DISPATCH_INIT_PROTOCAL = 'DISPATCH_INIT_PROTOCAL'

// 企业实名
export const SET_ENTERPRISE_CARD = 'SET_ENTERPRISE_CARD'
export const SET_ENTERPRISE_CERT = 'SET_ENTERPRISE_CERT'
export const SET_ENTERPRISE_PAPER = 'SET_ENTERPRISE_PAPER'
export const SET_ENTERPRISE_FILE = 'SET_ENTERPRISE_FILE'
export const SET_ENTERPRISE_CERT_IMAGE = 'SET_ENTERPRISE_CERT_IMAGE'
export const SET_ENTERPRISE_OWNER = 'SET_ENTERPRISE_OWNER'
export const SET_ENTERPRISE_IDCARD = 'SET_ENTERPRISE_IDCARD'
export const SET_ENTERPRISE_AGREEMENT = 'SET_ENTERPRISE_AGREEMENT'
export const SET_ENTERPRISE_DUTY_PIC = 'SET_ENTERPRISE_DUTY_PIC'
export const RESET_ENTERPRISE = 'RESET_ENTERPRISE'

// 从远程拉取告知书等内容
export const INIT_PAPER_FILE = 'INIT_PAPER_FILE'
export const RESET_PAPER_FILE = 'RESET_PAPER_FILE'

// 个人实名信息保存到storage中的数据
const STORE_PERSON_MARKUP_NAME = 'store-person-markup'
const STORE_ENTERPRISE_MARKUP_NAME = 'store-enterprise-markup'

export default {
  namespaced: true,
  state: {
    person: cache.get(STORE_PERSON_MARKUP_NAME, {}),
    protocal: {},
    ocrPic: {},
    enterprise: cache.get(STORE_ENTERPRISE_MARKUP_NAME, {})
  },
  mutations: {
    /**
     * 个人实名：初始化类型
     */
    [SET_PERSON_CONSIGNER](state, payload = {}) {
      // 开始赋值，但是不将其保存到缓存中
      state.person = {
        ...payload
      }
    },

    /**
     * 个人实名：设置基本信息
     */
    [SET_PERSON_BASE](state, payload = {}) {
      // 开始赋值
      state.person = {
        ...payload
      }
      // 将数据保存到缓存中
      cache.set(STORE_PERSON_MARKUP_NAME, state.person)
    },

    /**
     * 个人实名：设置车卡信息
     */
    [SET_PERSON_CARD](state, payload = {}) {
      state.person = {
        ...state.person,
        ...payload
      }
      // 将数据保存到缓存中
      cache.set(STORE_PERSON_MARKUP_NAME, state.person)
    },

    /**
     * 个人实名：设置文件信息
     */
    [SET_PERSON_FILE](state, payload) {
      state.person = {
        ...state.person,
        ...payload
      }
      // 将数据保存到缓存中
      cache.set(STORE_PERSON_MARKUP_NAME, state.person)
    },

    /**
     * 个人实名：设置身份证信息
     */
    [SET_PERSON_IDCARD](state, payload) {
      state.person = {
        ...state.person,
        ...payload
      }
      // 将数据保存到缓存中
      cache.set(STORE_PERSON_MARKUP_NAME, state.person)
    },

    /**
     * 个人实名：设置证件信息
     */
    [SET_PERSON_PAPER](state, payload) {
      state.person = {
        ...state.person,
        ...payload
      }
      // 将数据保存到缓存中
      cache.set(STORE_PERSON_MARKUP_NAME, state.person)
    },

    /**
     * 个人实名：签署协议告知书
     */
    [SET_PERSON_DUTY_PIC](state, payload) {
      state.person = {
        ...state.person,
        ...payload
      }
      // 将数据保存到缓存中
      cache.set(STORE_PERSON_MARKUP_NAME, state.person)
    },

    /**
     * 个人实名：签署协议信息
     */
    [SET_PERSON_AGREEMENT](state, payload) {
      state.person = {
        ...state.person,
        ...payload
      }
      // 将数据保存到缓存中
      cache.set(STORE_PERSON_MARKUP_NAME, state.person)
    },

    /**
     * 个人实名：清空实名信息
     */
    [RESET_PERSON](state) {
      // 清空数据
      state.person = {}
      // 先把数据移除
      cache.remove(STORE_PERSON_MARKUP_NAME)
    },

    /**
     * 个人实名：委托人信息
     */
    [SET_PERSON_CONSIGNER_CARD](state, payload) {
      // 记录当前填写的委托人信息
      state.person.consignerInfo = {
        ...(state.person.consignerInfo || {}),
        ...payload
      }
      // 将数据保存到缓存中
      cache.set(STORE_PERSON_MARKUP_NAME, state.person)
    },

    /**
     * 个人实名：初始化告知书等内容
     */
    [INIT_PAPER_FILE](state, payload) {
      // 将协议保存到本地
      state.protocal = {
        ...state.protocal,
        ...payload
      }
    },

    /**
     * 协议：清空协议
     */
    [RESET_PAPER_FILE](state, payload) {
      state.protocal = {}
    },

    /**
     * 企业实名：车卡信息
     */
    [SET_ENTERPRISE_CARD](state, payload) {
      state.enterprise = {
        ...state.enterprise,
        ...payload
      }
      // 将数据保存到缓存中
      cache.set(STORE_ENTERPRISE_MARKUP_NAME, state.enterprise)
    },

    /**
     * 企业实名：企业信息
     */
    [SET_ENTERPRISE_CERT](state, payload) {
      state.enterprise = {
        ...state.enterprise,
        ...payload
      }
      cache.set(STORE_ENTERPRISE_MARKUP_NAME, state.enterprise)
    },

    /**
     * 企业实名：企业证件信息
     */
    [SET_ENTERPRISE_CERT_IMAGE](state, payload) {
      state.enterprise = {
        ...state.enterprise,
        ...payload
      }
      cache.set(STORE_ENTERPRISE_MARKUP_NAME, state.enterprise)
    },

    /**
     * 企业实名：责任人身份信息
     */
    [SET_ENTERPRISE_OWNER](state, payload) {
      state.enterprise = {
        ...state.enterprise,
        ...payload
      }
      cache.set(STORE_ENTERPRISE_MARKUP_NAME, state.enterprise)
    },

    /**
     * 企业实名：责任人证件信息
     */
    [SET_ENTERPRISE_PAPER](state, payload) {
      state.enterprise = {
        ...state.enterprise,
        ...payload
      }
      cache.set(STORE_ENTERPRISE_MARKUP_NAME, state.enterprise)
    },

    /**
     * 企业实名;责任人证件信息
     */
    [SET_ENTERPRISE_IDCARD](state, payload) {
      state.enterprise = {
        ...state.enterprise,
        ...payload
      }
      cache.set(STORE_ENTERPRISE_MARKUP_NAME, state.enterprise)
    },

    /**
     * 企业实名：文件信息
     */
    [SET_ENTERPRISE_FILE](state, payload) {
      state.enterprise = {
        ...state.enterprise,
        ...payload
      }
      cache.set(STORE_ENTERPRISE_MARKUP_NAME, state.enterprise)
    },

    /**
     * 企业实名：入网协议
     */
    [SET_ENTERPRISE_AGREEMENT](state, payload) {
      state.enterprise = {
        ...state.enterprise,
        ...payload
      }
      cache.set(STORE_ENTERPRISE_MARKUP_NAME, state.enterprise)
    },

    /**
     * 企业实名：责任告知书
     */
    [SET_ENTERPRISE_DUTY_PIC](state, payload) {
      state.enterprise = {
        ...state.enterprise,
        ...payload
      }
      cache.set(STORE_ENTERPRISE_MARKUP_NAME, state.enterprise)
    },

    /**
     * 设置ocr的图片
     */
    [SET_OCR_PIC](state, payload) {
      state.ocrPic = payload || {}
    },

    /**
     * 重置ocr的图片
     */
    [RESET_OCR_PIC](state, payload) {
      state.ocrPic = {}
    },

    /**
     * 重置企业信息
     */
    [RESET_ENTERPRISE](state, payload) {
      state.enterprise = {}
      cache.remove(STORE_ENTERPRISE_MARKUP_NAME)
    }
  },
  actions: {
    /**
     * 初始化告知书
     */
    async [DISPATCH_INIT_PROTOCAL]({ commit }) {
      try {
        // 查询当前登录人的组织下的协议
        const protocal = await queryPotocolCustomerManage()
        // 提交协议
        commit(INIT_PAPER_FILE, protocal)
      } catch (error) {
        commit(RESET_PAPER_FILE)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/markup.js